import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getClubsAdminRequest } from '../../../redux/action'
import OpticsCard from '../ClubMembers/OpticsCard'
import ProfileAvatar from '../global/ProfileAvatar'
import AvailableClubMemberships from './AvailableClubMemberships'

const ClubSubscriptionBody = () => {

    // OBJECT INITIALIZATION
    // dispatch object
    const dispatch = useDispatch()


    // STATES
    const { clubs } = useSelector(state=>{
        const { clubs } = state.clubsReducer
        return {
            clubs
        }
    })


    // SIDE EFFECTS
    useEffect(()=>{
        dispatch(getClubsAdminRequest())
    }, [])


    return (
        <section className='w-[80vw] mobile:w-full bg-[#E5E5E5] py-16 mobile:pb-8 mobile:px-0 px-12'>

            {/* header */}
            <header  className='container mx-auto mobile:px-4 flex justify-between items-center'>
                <div>
                    <p className='text-4xl mobile:leading-9 mobile:text-2xl font-semibold leading-[54px] text-[#1D2433]'>
                        Club subscription
                    </p>
                </div>

                {/* profile dp */}
                <div className='mobile:hidden'>
                    <ProfileAvatar />
                </div>
            </header>

            {/* body section */}
            <section className='container mx-auto w-full mt-12 mobile:px-4 flex flex-col gap-9'>

                <OpticsCard
                totalMembers={1000}
                availableSubscription={4}
                currentlySubscribed={3} />

                <AvailableClubMemberships
                clubs={clubs} />
            
            </section>
        </section>
    )
}

export default ClubSubscriptionBody